/**
 * Per-user flag (localStorage) that records whether a Corporate / Policy Maker
 * user has already seen the LandingPage. First login shows the landing with a
 * "Continue to Dashboard" button; subsequent logins jump straight to alerts.
 */

const STORAGE_KEY_PREFIX = 'landing_seen_';

function getUserKey(user) {
  if (!user || typeof user !== 'object') return null;
  const id = user.id ?? user.user_id ?? user.username ?? user.email;
  if (id == null) return null;
  const cleaned = String(id).trim();
  if (!cleaned) return null;
  return `${STORAGE_KEY_PREFIX}${cleaned}`;
}

export function hasSeenLanding(user) {
  const key = getUserKey(user);
  if (!key) return false;
  try {
    return localStorage.getItem(key) === '1';
  } catch (_) {
    return false;
  }
}

export function markLandingSeen(user) {
  const key = getUserKey(user);
  if (!key) return;
  try {
    localStorage.setItem(key, '1');
  } catch (_) {
    /* ignore */
  }
}

export function clearLandingSeen(user) {
  const key = getUserKey(user);
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch (_) {
    /* ignore */
  }
}
